import { render, staticRenderFns } from "./RemoteSelect.vue?vue&type=template&id=8f1b01b6&scoped=true&"
import script from "./RemoteSelect.vue?vue&type=script&lang=ts&"
export * from "./RemoteSelect.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteSelect.vue?vue&type=style&index=0&id=8f1b01b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1b01b6",
  null
  
)

export default component.exports